<template>
    <div class="mt-12">
        <div class="row">
            <div class="col-lg-12">
                <div class="formCnt">
                    <div class="LogoName">
                        <div style="display: flex; justify-content: space-between;">
                            <!-- <img src="../assets/appmart logo png.png" alt="" srcset="" width="50%"> -->
                            <v-divider></v-divider>
                            <h6 class="agnt">AGENT</h6>
                        </div>
                    </div>
                    <v-card class="mx-auto elevation-4 pa-3" max-width="600" outlined>
                        <p class="instruct" style="text-align: left"><strong>Instructions:</strong> Please Fill the Form
                            in BLOCK
                            Letters
                            Only. All fields with
                            (*) are Mandatory.</p>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div>
                                            <label class="text">Surname</label>
                                            <input v-model="surname" type="text" class="formInp" placeholder="Surname">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div>
                                            <label class="text">First Name</label>
                                            <input v-model="name" type="text" class="formInp" placeholder="First Name">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div>
                                            <label class="text">Contact/Phone
                                                number</label>
                                            <input v-model="phone" type="text" class="formInp"
                                                placeholder="Contact Phone No">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div>
                                            <label class="text">Residential
                                                Address</label>
                                            <input v-model="residentialA" type="text" class="formInp"
                                                placeholder="Residential Address">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-lg-1">
                                <div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" id="flexChec"
                                        >
                                        <label class="form-check-label">
                                            Male
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-1">
                                <div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" id="flexChec"
                                        >
                                        <label class="form-check-label">
                                            Female
                                        </label>
                                    </div>
                                </div>
                            </div> -->
                        <div class="row">
                            <div class="col-lg-12">
                                <label class="text">Gender</label>
                                <v-select v-model="gender" :items="genders" label="Gender" solo></v-select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <label class="text">Date of Birth</label>
                                <div data-app>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="12">
                                            <v-menu v-model="dateModal" :close-on-content-click="false"
                                                :nudge-right="40" transition="scale-transition" offset-y
                                                min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field v-model="date1" prepend-icon="mdi-calendar" readonly
                                                        v-bind="attrs" v-on="on">
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker v-model="date1" @input="menu2 = false">
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="mb-2 col-lg-12">
                                <label class="text">Place of Birth</label>
                                <input v-model="placeofBirth" type="email" class="formInp" placeholder="Place of Birth">
                            </div>
                        </div>
                        <div class="row">
                            <label class="text">ID Type</label>
                            <div class="col-lg-12">
                                <v-select v-model="idType" :items="Idtypes" label="ID Type" solo></v-select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <label class="text">ID Number</label>
                                <input v-model="idnumber" type="text" class="formInp" placeholder="ID Number">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div>
                                            <label class="text">Nationality</label>
                                            <input type="text" v-model="nationality" class="formInp"
                                                placeholder="Nationality">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div>
                                            <label class="text">Mother's Maiden
                                                Name</label>
                                            <input v-model="motherName" type="text" class="formInp"
                                                placeholder="Mother's Maiden Name">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <button @click="openSecond" class="btnNXT">Next </button>
                            </div>
                        </div>
                    </v-card>
                </div>
            </div>
        </div>

        <!-- SECOND ROW -->
        <div v-if="secondRow" class="row">
            <v-card class="mx-auto elevation-4 pa-3" max-width="600" outlined>
                <div class="col-lg-12">
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Business Name</label>
                                <input v-model="businessName" type="text" class="formInp" placeholder="Business Name">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Business Address</label>
                                <input v-model="businessAddress" type="text" class="formInp"
                                    placeholder="Business Address">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">City/Town</label>
                                <input v-model="city" type="text" class="formInp" placeholder="City/Town">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">State</label>
                                <input v-model="state" type="text" class="formInp" placeholder="State">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Ward</label>
                                <input v-model="ward" type="text" class="formInp" placeholder="Ward">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">LGA</label>
                                <input v-model="lga" type="text" class="formInp" placeholder="LGA">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Company Registration No</label>
                                <input v-model="compReg" type="text" class="formInp"
                                    placeholder="Company Registration No">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Agent's Mobile Number</label>
                                <input v-model="agenMobile" type="text" class="formInp"
                                    placeholder="Agent's Mobile Number">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <label class="text">Type of Agent</label>
                        <div class="col-lg-12">
                            <v-select v-model="agentType" :items="agentTypes" label="Agent Type" solo></v-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Bank Name</label>
                                <input v-model="bankName" type="text" class="formInp" placeholder="Bank Name">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Bank Verification No (BVN)</label>
                                <input v-model="bvn" type="text" class="formInp"
                                    placeholder="Bank Verification No (BVN)">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Account Number</label>
                                <input v-model="accNo" type="text" class="formInp" placeholder="Account Number">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <label class="text">Account Type</label>
                        <div class="col-lg-12">
                            <v-select v-model="accType" :items="accTypes" label="Agent Type" solo></v-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Email Address</label>
                                <input v-model="agntEmail" type="email" class="formInp" placeholder="Email Address">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Agent Name & Signature</label>
                                <input type="text" class="signature" placeholder="Agent Name & Signature">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Date</label>
                                <div data-app>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="12">
                                            <v-menu v-model="dateModal2" :close-on-content-click="false"
                                                :nudge-right="40" transition="scale-transition" offset-y
                                                min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field v-model="date2" prepend-icon="mdi-calendar" readonly
                                                        v-bind="attrs" v-on="on">
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker v-model="date2" @input="menu2 = false"></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <button @click="openthird" class="btnNXT">Next </button>
                        </div>
                    </div>
                </div>
            </v-card>
        </div>
        <!-- THIRD ROW -->
        <div v-if="thirdRow" class="row">
            <v-card class="mx-auto elevation-4 mt-3 pa-3" max-width="600" outlined>
                <p style="text-align: left"><strong>To be filled by the Guarantor:</strong>.</p>
                <div class="col-lg-12">
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Full Name</label>
                                <input v-model="gFullname" type="text" class="formInp" placeholder="Full Name">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Residential Address</label>
                                <input v-model="gresident" type="text" class="formInp"
                                    placeholder="Residential Address">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Mobile Number</label>
                                <input v-model="gmobile" type="text" class="formInp" placeholder="Mobile Number">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Email Addrsss</label>
                                <input v-model="gemail" type="text" class="formInp" placeholder="Email Addrsss">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Relationship</label>
                                <input v-model="gRelation" type="text" class="formInp" placeholder="Relationship">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Signature & Date</label>
                                <input type="text" class="signature" placeholder="Signature & Date">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <button @click="openUpload" class="btnNXT">Next </button>
                        </div>
                    </div>
                </div>
            </v-card>
        </div>

        <!-- OFFFICIAL USE -->
        <!-- <div v-if="officialRow" class="row">
            <v-card class="mx-auto elevation-4 mt-3 pa-3" max-width="600" outlined>
                <div class="row">
                    <div class="col-lg-12">
                        <v-data-table hide-default-footer :headers="headers" :items="desserts" :items-per-page="5"
                            class="elevation-1">
                            <template v-slot:[`item.tick`]="{  }">
                                <v-checkbox v-model="checkbox"></v-checkbox>
                            </template>
                        </v-data-table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row">
                            <div class="col-lg-12">
                                <div>
                                    <label class="text">Approved by</label>
                                    <input type="text" class="formInp" placeholder="Approved by">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div>
                                    <label class="text">Name</label>
                                    <input type="text" class="formInp" placeholder="Name">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <button @click="saveAgent" class="btnNXT">Submit </button>
                    </div>
                </div>
            </v-card>
        </div> -->
        <div v-if="uplaoads" class="row">
            <v-card class="mx-auto elevation-4 mt-3 pa-3" max-width="600" outlined>
                <div class="row">
                    <div class="col-lg-12">
                        <label class="text">Upload Passport</label>
                        <input type="file" ref="img" @change="uploadFile" name='passport'
                            placeholder="Upload Passport" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <label class="text">Upload Government Identification</label>
                        <input type="file" ref="img2" @change="uploadFile2" name='govId' placeholder="Upload ID" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <button @click="saveAgent" class="btnNXT">Submit </button>
                    </div>
                </div>
            </v-card>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import Swal from 'sweetalert2'

export default {
    data: () => ({
        genders: ['Male', 'Female'],
        Idtypes: ['Passport', 'Driver Liscence', 'National ID', 'Vater Card'],
        agentTypes: ['Aggregator', 'Agent'],
        accTypes: ['Savings', 'Current'],
        date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        modal: false,
        dateModal: false,
        dateModal2: false,
        secondRow: false,
        thirdRow: false,
        uplaoads: false,
        officialRow: false,
        checkbox: true,

        // FORM FIELDS
        surname: '',
        name: '',
        phone: '',
        residentialA: '',
        gender: '',
        idType: '',
        accType: '',
        agentType: '',
        image: '',
        govIdCard: '',
        placeofBirth: '',
        // Passport: '',
        // liscence: '',
        // nationalId: '',
        nationality: '',
        idnumber: '',
        // vcard: '',
        motherName: '',

        // SecondRow
        businessName: '',
        businessAddress: '',
        city: '',
        state: '',
        ward: '',
        lga: '',
        compReg: '',
        agenMobile: '',
        // aggregator: '',
        // agent: '',
        bankName: '',
        bvn: '',
        accNo: '',
        // saving: '',
        // current: '',
        agntEmail: '',

        // Gurantor
        gFullname: '',
        gresident: '',
        gmobile: '',
        gemail: '',
        gRelation: '',


        headers: [
            {
                text: 'Aggent Registration Requirements',
                align: 'start',
                sortable: false,
                value: 'requirements',
            },
            { text: 'Aggregator', value: 'aggregator' },
            { text: 'Agent', value: 'agent' },
            { text: 'Tick', value: 'tick' },
        ],
        desserts: [
            {
                requirements: 'Certificate of Business Incorporative (If Any)',
                aggregator: '',
                agent: '',
                tick: '',
            },
            {
                requirements: 'Memorandum and Article of Associaion (MEMART) (If Any)',
                aggregator: '',
                agent: '',
                tick: '',
            },
            {
                requirements: 'Guarantors Official ID and Passport Photo',
                aggregator: '',
                agent: '',
                tick: '',
            },
            {
                requirements: 'Evidence of Existing Three months Bank Statement',
                aggregator: '',
                agent: '',
                tick: '',
            },
            {
                requirements: 'Proof of Address (Utility Bill or Rent Receipt)',
                aggregator: '',
                agent: '',
                tick: '',
            },
            {
                requirements: 'Signed Legal Agency Aggreement Form',
                aggregator: '',
                agent: '',
                tick: '',
            },
            {
                requirements: 'Certificate of good conduct (court Affidavit, or A letter from AMMAN)',
                aggregator: '',
                agent: '',
                tick: '',
            },
            {
                requirements: 'Endorsed Copies of Acceptable ID Cards',
                aggregator: '',
                agent: '',
                tick: '',
            },
            {
                requirements: '2 Passport Photograph',
                aggregator: '',
                agent: '',
                tick: '',
            },
        ],
    }),
    methods: {
        uploadFile() {
            this.image = this.$refs.img.files[0];
            console.log(this.image);
        },
        uploadFile2() {
            this.image = this.$refs.img2.files[0];
            console.log(this.image);
        },
        openSecond() {
            if (this.motherName === '') {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Please Complete the form!',
                    width: 400,
                    showConfirmButton: false,
                    timer: 1500
                })
            } else {
                this.secondRow = true
            }
        },
        openthird() {
            if (this.agntEmail === '') {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Please Complete the form!',
                    width: 400,
                    showConfirmButton: false,
                    timer: 1500
                })
            } else {
                this.thirdRow = true
            }
        },
        openofficial() {
            this.officialRow = true
        },
        openUpload() {
            if (this.gFullname === '') {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Please Complete the form!',
                    width: 400,
                    showConfirmButton: false,
                    timer: 1500
                })
            } else {
                this.uplaoads = true
            }
        },
        async saveAgent() {
            const formData = new FormData();

            formData.append('passport', this.image);
            formData.append('govId', this.govIdCard);
            formData.append('surName', this.surname)
            formData.append('firstName', this.name)
            formData.append('phoneNo', this.phone)
            formData.append('residentialAddress', this.residentialA)
            formData.append('idNumber', this.idnumber)
            formData.append('gender', this.gender)
            formData.append('dateofBirth', this.date1)
            formData.append('placeofBirth', this.placeofBirth)
            formData.append('idType', this.idType)
            formData.append('nationality', this.nationality)
            formData.append('motherName', this.motherName)
            formData.append('businessName', this.businessName)
            formData.append('businessAddress', this.businessAddress)
            formData.append('city', this.city)
            formData.append('state', this.state)
            formData.append('emailAdd', this.agntEmail)
            formData.append('ward', this.ward)
            formData.append('lga', this.lga)
            formData.append('compReg', this.compReg)
            formData.append('agentsNumber', this.agenMobile)
            formData.append('typeOfAgent', this.agentType)
            formData.append('bankName', this.bankName)
            formData.append('bankVn', this.bvn)
            formData.append('accountNo', this.accNo)
            formData.append('accountType', this.accType)
            formData.append('gfullName', this.gFullname)
            formData.append('greside', this.gresident)
            formData.append('gnumber', this.gmobile)
            formData.append('gEmail', this.gemail)
            formData.append('relationship', this.gRelation)
            const url = process.env.VUE_APP_UB_V1_API_ENDPOINT+`form`
            await axios.post(url, formData)
                .then((response) => {
                    console.log(response);
                })
                .catch((error) => {
                    console.log(error);
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.formInp {
    background: #FFFFFF;
    border: 1px solid #DFDFDF;
    border-radius: 3px;
    width: 100%;
    height: 45px;
    padding: 0 10px;

    font-family: 'Proxima Nova';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    /* identical to box height */
    text-align: left;
    color: #4F4F4F;

}

.signature {
    // background: #FFFFFF;
    border-bottom: 1px solid #DFDFDF;
    border-radius: 3px;
    width: 100%;
    height: 45px;
    padding: 0 10px;

    font-family: 'Proxima Nova';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    /* identical to box height */
    text-align: left;
    color: #4F4F4F;

}

.btnNXT {
    width: 177px;
    height: 49px;
    background: #21618C;
    border-radius: 5px;
    font-family: 'Proxima Nova';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 20px;
    text-align: center;
    color: #FFFFFF;
}

.formCnt {
    width: 100%;
    // height: 100vh;

    .LogoName {
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        width: 100%;
    }

}

.agnt {
    font-size: 2rem;
    margin-left: 1rem;
}

.instruct {
    font-family: 'Proxima Nova';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 110%;
    color: #4F4F4F;
}

.text {
    text-align: left;
    font-family: 'Proxima Nova';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    color: #4F4F4F;
}
</style>